'use strict';

module.exports = require('react').addons.PureRenderMixin;
